const originMap = {
    pro: 'https://liveapi.upliveapps.com/uplive/get-download-settings',
    stage: 'http://sg-liveapi.xingyunzhi.cn/uplive/get-download-settings',
}
import url from 'c-url';

export default {
    downloadUrl: {
        yyb: '',
        apple: '',
        google: '',
        android: '',
    },
    load() {
        // 当前开发环境
        var env = url.query('env');

        if (!env || env == 'null') {
            env = 'pro';
        }

        let API = originMap[env] || originMap['pro'];

        let promise = $.ajax({
            url: API,
            type: 'POST',
            dataType: 'json'
        });

        promise.done((res) => {
            let { yyb, ios, googleplay, apk } = res.data.download_url;

            this.downloadUrl = {
                yyb: yyb,
                apple: ios,
                google: googleplay,
                android: apk,
            };
        });
    }
};


// WEBPACK FOOTER //
// ./js/component/download/index.js